import {  useState, useContext, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon } from '@mdi/react';
import { mdiMenu } from '@mdi/js';
import { resource_server } from "@utils/settings";
import { GlobalStateContext } from "@utils/GlobalContext";
import CambiaRuolo from "@ui/CambiaRuolo";

function Nav() {
    const { settings, profile, hideMenu } = useContext(GlobalStateContext);
    const [visible, setVisible] = useState(false);
    const location = useLocation();
    const menuRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 935) {
                setVisible(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target) && window.innerWidth <= 935) {
                setVisible(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [menuRef]);

    useEffect(() => {
        if (visible) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }
    }, [visible]);

    const handleLinkClick = () => {
        if (window.innerWidth <= 935) {
            setVisible(false);
        }
    };



    return (
        !hideMenu&&<>
            <button className="menu-btn" onClick={() => { setVisible(!visible) }}>
                <Icon path={mdiMenu} size={1} />
            </button>
            {visible && <div className="overlay" onClick={() => setVisible(false)}></div>}
            {settings && (
                <ul ref={menuRef} className={visible ? 'open left-menu' : 'left-menu'}>
                    <li className="h3 brand" style={{ margin: '0', width: '100%' }}>
              <div className="logo-rotondo"></div>
                    </li>
                    <li onClick={handleLinkClick} className={location.pathname === "/profilo" ? "current" : ""}>
                        <Link to={"/profilo"} className="menu-singolo">
                            <i className="icon icon-menu icon-user-menu"></i>
                            <span>Profilo</span>
                        </Link>
                    
                    </li>
                    
                    {Object.keys(profile).length>0&&profile.roles.length > 1&&<li style={{marginBottom: '0'}}>
                        <CambiaRuolo />
                    </li>}
                    
                    <hr />

                        <li  onClick={handleLinkClick} className={location.pathname === '/'|| location.pathname === ''?'current':''}>
                            <Link to={'/'}>
                                <i className={`icon icon-menu icon-home`}></i>
                                <span>Home</span>
                            </Link>
                            
                        </li>                    
                        <li onClick={handleLinkClick} className={location.pathname === "/contratti" ? "current" : ""}>
                            <Link to={"/contratti"}>
                                <i className="icon icon-menu icon-credit"></i>
                                <span>Contratti</span>
                            </Link>
                        </li>
                        
                    {settings.menu.map((item, index) => (

                        <li key={index} onClick={handleLinkClick} className={location.pathname === item.route || ((location.pathname === '/home/esercente'|| location.pathname === '/home/cliente'|| location.pathname ==='/'|| location.pathname === '/home/admin')&&(item.route === '/home' || item.route ==='/'|| item.route ==='/home/cliente'|| item.route ==='/home/esercente'|| item.route ==='/home/admin')) ? "current" : ""}>
                            <Link to={item.route}>
                                <i className={item.icon!="account-tie"?item.icon:"icon-customers"}></i>
                                <span>{item.label}</span>
                            </Link>
                            
                        </li>
                    ))}
                    <hr />

                    <li onClick={handleLinkClick} className="mb-7">
                        <Link to="/" onClick={() => { window.location.href = `${resource_server}/logout?referrer=${window.location.origin}` }}>
                            <i className="icon icon-menu icon-logout"></i>
                            <span>Logout</span>
                        </Link>
                    </li>
                </ul>
            )}
            {/* {!settings && <small className="left-menu">Loading...</small>} */}
            {/* {profile&&Object.keys(profile).length>0&&<div className="richiedi-assistenza-container"></div>} */}
        </>
    );
}

export default Nav;
